import styled, { css } from 'styled-components';

import config from '../../config';
import { useTranslation } from 'react-i18next';
import { isCustomError } from '../../components/ErrorBoundary/errors';

interface ErrorPageProps {
  error?: Error;
}

export function ErrorPage({ error }: ErrorPageProps) {
  const { t } = useTranslation('errorPage');

  const errorCode = isCustomError(error) ? error.code : 500;

  return (
    <Wrapper>
      <Image src="https://images.justgiving.com/image/error_500.gif" alt="" />
      <div>
        <h2>{t('heading')}</h2>
        <p>{t('subHeading')}</p>
        {error?.message && (
          <p>{`ERROR ${errorCode}: ${error.message.toUpperCase() ?? ''}`}</p>
        )}
        <a href={config.basePath}>{t('link')}</a>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  gap: ${({ theme }) => theme.layout.sizeSpacing05};
  padding: ${({ theme }) => theme.layout.sizeSpacing03};
  flex-direction: row;

  @media screen and (max-width: ${page => page.theme.mediaQuery.mq592}) {
    flex-direction: column;
  }
`;

const Image = styled.img`
  width: 100%;
  max-width: ${({ theme }) => css`calc(${theme.layout.sizeSpacing12} * 3)`};
`;
